package com.essntl.features.task.ui.alltasks.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.FocusRequester
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.features.task.ui.alltasks.AllTasksEvent
import com.essntl.features.task.ui.alltasks.AllTasksNavigation
import com.essntl.features.task.ui.alltasks.AllTasksState
import com.essntl.uikit.components.button.outline.EsMediumOutlineButton
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.key.upDownSelection
import com.essntl.uikit.rememberEquals
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

@Composable
fun TaskListColumn(
    state: AllTasksState,
    onEvent: (AllTasksEvent) -> Unit,
    onNavigation: (AllTasksNavigation) -> Unit,
    selectedTask: TaskModel,
    isLoading: Boolean,
    modifier: Modifier = Modifier,
    overdue: Boolean = false,
) {
    val taskState = state.getAllTasks

    val scope = rememberCoroutineScope()
    val lazyListState = rememberLazyListState()

    Box(
        contentAlignment = Alignment.Center,
        modifier = modifier
            .fillMaxSize()
            .clip(RoundedCornerShape(EsConstants.RoundedCornerSize)),
    ) {
        LazyColumn(
            verticalArrangement = Arrangement.spacedBy(EsConstants.ListRowVerticalSpacing),
            horizontalAlignment = Alignment.CenterHorizontally,
            contentPadding = PaddingValues(
                vertical = EsConstants.SectionVerticalPadding,
            ),
            state = lazyListState,
            modifier = Modifier
                .fillMaxSize(),
        ) {
            itemsIndexed(
                if (overdue)
                    state.getAllOverDueTasks.data.orEmpty() else
                    taskState.data,
                key = { _, r -> r.id },
            ) { index, task ->
                val isSelected = rememberEquals(task.id, setOf(selectedTask.id)) { it }

                val focusRequester = remember { FocusRequester() }

                LaunchedEffect(isSelected) {
                    delay(100L)
                    if (isSelected)
                        focusRequester.requestFocus()
                }

                TaskItem(
                    state = state,
                    onEvent = onEvent,
                    onNavigation = onNavigation,
                    index = index,
                    task = task,
                    isSelected = isSelected,
                    overdue = overdue,
                    modifier = Modifier
                        .upDownSelection(
                            focusRequester = focusRequester,
                            isSelected = isSelected,
                            list = taskState.data,
                            index = index,
                            onSelect = {
                                onNavigation(AllTasksNavigation.EditTask(it.id))
                            },
                            lazyListState = lazyListState,
                            scrollTo = { scope.launch { lazyListState.animateScrollToItem(it) } },
                        )
                        .padding(
                            horizontal = EsConstants.SectionHorizontalPadding,
                        ),
                )
            }

            if (!overdue &&
                !taskState.isLastPage
            ) {
                item {
                    Spacer(modifier = Modifier.height(2.spacing))
                    EsMediumOutlineButton(
                        onClick = {
                            onEvent(AllTasksEvent.LoadTasks())
                        },
                        text = "Load more",
                        loading = isLoading,
                        modifier = Modifier
                            .align(Alignment.Center),
                    )
                    Spacer(modifier = Modifier.height(2.spacing))
                }
            }
        }
    }
}